const SERVER_URL = "https://clementcareercollege-backend-nodejs-kdtagrlkqq-uc.a.run.app/"
  const IMAGE_URL = 
  "https://storage.googleapis.com/clement-career-college/"
module.exports = {
  SERVER_URL,IMAGE_URL
};